<div>
  <a routerLink="/">Home</a>
  <a [routerLink]="['/basic-update']">Updating</a>
  <a [routerLink]="['/', 'bar']">Bar</a>
  <a [routerLink]="['/', 'pie']">Pie</a>
  <a [routerLink]="['/', 'line']">Line</a>
  <a [routerLink]="['/', 'multi-line']">Multiline</a>
  <a [routerLink]="['/', 'stacked-area']">StackedArea</a>
  <a [routerLink]="['/', 'stacked-bars']">StackedBars</a>
</div>
